import { render, staticRenderFns } from "./block-preview.vue?vue&type=template&id=7fbd2a4b"
import script from "./block-preview.vue?vue&type=script&lang=js"
export * from "./block-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports